import { AppLauncher } from '@capacitor/app-launcher'
import OneSignal from 'onesignal-cordova-plugin'

import { appConfig } from './config'
import { getToken } from './token'

export const pushNotificationsInit = (): void => {
  if (!appConfig.oneSignalAppId) return
  OneSignal.setAppId(appConfig.oneSignalAppId)
  OneSignal.setNotificationOpenedHandler(function (jsonData) {
    console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData))
  })

  OneSignal.getDeviceState((device) => {
    if (!device?.userId) {
      OneSignal.promptForPushNotificationsWithUserResponse(function (accepted) {
        console.log('User accepted notifications: ' + accepted)
      })
    }
  })

  window?.plugins?.OneSignal.setNotificationOpenedHandler((jsonData) =>
    AppLauncher.openUrl({ url: jsonData?.notification?.launchURL })
  )
}

export const setPushNotificationsExternalUserId = async (id: UUID) => {
  if (!appConfig.oneSignalAppId) return

  const token = await getToken()
  return await window?.plugins?.OneSignal.setExternalUserId(
    id,
    token.oneSignalUserIdToken,
    (results) => {
      console.log('Results of setting external user id')
      for (const channel in results) {
        if (results[channel] && results[channel].success) {
          console.log(`Results of setting external user id ${channel} status:`)
          console.log(results[channel].success)
        }
      }
    }
  )
}

export const removePushNotificationsExternalUserId = async () => {
  if (!appConfig.oneSignalAppId) return

  return await window?.plugins?.OneSignal.removeExternalUserId()
}
